import { TreeviewItem } from '@ingenmaffen/ngx-treeview';
import { getSelectors, RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState, Contract, Tag } from './app.models';
import { CustomTreeviewItem } from './CustomTreeviewItem';

const buildTree = (items: Tag[], parentId = null) =>
  items
    .filter(item => item.parentId === parentId)
    .map(item => (new CustomTreeviewItem({
      text: item.name,
      value: item.id,
      checked: false,
      children: buildTree(items, item.id)
    })));

export const selectRouter = createFeatureSelector<AppState, RouterReducerState<any>>('router');
export const {
  selectCurrentRoute,
  selectFragment,
  selectQueryParams,
  selectQueryParam,
  selectRouteParams,
  selectRouteParam,
  selectRouteData,
  selectUrl,
} = getSelectors(selectRouter);

export const selectContract = createSelector(
  (state: AppState) => state.contract,
  (state: AppState) => state.contract.selectedContract,
  ((contract, current): Contract => (contract.contracts.find(c => c.clientId === current)))
);

export const selectClientId = createSelector((state: AppState) => state.contract.selectedContract, (e): string => e);

export const selectBaseEndpoint = createSelector(
  (state: AppState) => state.contract,
  (state: AppState) => state.contract.selectedContract,
  ((contract, current): string => (contract.contracts.find(c => c.clientId === current)?.baseUrl?.slice(0, -1)))
);

export const selectApiEndpoint = createSelector(
  selectBaseEndpoint,
  (base): string => base ? base + '/push-admin-api/v3' : null
);

export const selectCustomerApiEndpoint = createSelector(
  selectApiEndpoint,
  (state: AppState) => state.contract.selectedContract,
  (api, contract): string => api ? `${api}/${contract}` : null
);

export const selectTestPushCredentials = createSelector(
  (state: AppState) => state.customerInfo.pushUser,
  ((pushUser) => pushUser)
);

export const selectTreeViewGroups = createSelector(
  (state: AppState) => state.tags,
  (tags): TreeviewItem[] => buildTree([{ name: 'Root', parentId: null, id: 0 } as Tag, ...tags.filter(t => t.group)])
);

export const selectTreeView = createSelector(
  (state: AppState) => state.tags,
  (tags): TreeviewItem[] => buildTree([...tags], 0)
);
